module.exports = __webpack_public_path__ + "04_medium_grey.83f493e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_medium_grey.png
// module id = OGmH
// module chunks = 0